import React, { useState } from 'react'
import { Tabs, Button, Form, Input, Alert, message, Modal, Typography, Space, Collapse } from 'antd';
import { useAuth } from 'bxl-auth'
import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';

const { TabPane } = Tabs;


const BotHook = () => {
  const { user } = useAuth()

  const [formSubmit] = Form.useForm();

  const [activeKey, changeActiveKey] = useState('1')

  const formItemLayout = {
    labelCol: {
      span: 4,
    },
    wrapperCol: {
      span: 14,
    },
  }
  const buttonItemLayout = {
    wrapperCol: {
      span: 14,
      offset: 4,
    },
  }

  const reCrawler = (values) => {
    let { url, color, size } = values
    url = url?.trim()
    if (!url) return message.error('url 不能为空')
    const data = {
        requestId: uuidv4()
    }
    if (!!url) data['url'] = url
    data['size'] = size
    data['color'] = color
    axios.post(`https://browser-bot.bybieyang.com/webhook`,data, {
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((res) => {
      message.success('提交成功')
    }).catch(error => {
      message.error(JSON.stringify(error));
    })
  }


  return <section>
    <Tabs activeKey={activeKey} onChange={(k) => changeActiveKey(k)}>
      <TabPane tab="商品八爪鱼" key="1">
        <Form
          {...formItemLayout}
          name='crawler'
          layout={{
            wrapperCol: {
              span: 14,
              offset: 4,
            },
          }}
          onFinish={reCrawler}
          form={formSubmit}
          initialValues={{
            layout: 'horizontal',
          }}
        >
          <Alert message="如需查询爬取结果，请查看Lark群组(shopping-agent-bot-test)" type="info" style={{ marginBottom: '20px' }} />
          
          <Form.Item label="url" name='url' required>
            <Input placeholder="http://xxxx | https://xxx" />
          </Form.Item>
          <Form.Item label="color" name='color'>
            <Input placeholder="color（选填）" />
          </Form.Item>
          <Form.Item label='size' name='size'>
            <Input placeholder="size (选填）" />
          </Form.Item>
          <Form.Item {...buttonItemLayout}>
            <Button type="primary" htmlType='submit'>提交</Button>
          </Form.Item>
        </Form>
      </TabPane>
    </Tabs>
  </section>
}

export default BotHook